// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__JCqsl","label":"Radio_label__20OtC","checkMark":"Radio_checkMark__2yBQZ","disabled":"Radio_disabled__W9Xvl"};